import React, { useState, useEffect } from 'react';
import axios from 'axios';

// https://stackoverflow.com/questions/33973757/how-can-i-render-html-from-another-file-in-a-react-component
// https://medium.com/trabe/react-useeffect-hook-44d8aa7cccd0

/*
interface iFound {  
  document: string;  
}
*/

export default (props) => // functional component written in ES6 
{
  const [Document, setDocument] = useState([]);
  useEffect(() => {   // replace componentDidMount, componentDidUpdate, etc.
    const searchkey = props.match.params.name
    axios({
      method: "POST",
      url: "/api/db/dbDocuments2",
      data: { SearchKey: searchkey }   // Fester Wert - muss parameterisiert werden. Server muss aktuelle AGB raussuchen

    }).then((response) => {
    // debugger
      setDocument(response.data);
    })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Object is possibly 'undefined'.ts(2532)
  //  console.log(Document)
  return (
    <div dangerouslySetInnerHTML={{ __html: Document.document }} style={{ border: "2px solid #ccc", padding: 5, margin: 5, }} />
  )
}


//  <div dangerouslySetInnerHTML={{ __html: Document.document }} style={{ border: "2px solid #ccc", padding: 5, margin: 5, }} />